/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceAccountUserRequest } from '../../models/service-account-user-request';
import { UserAccountService } from '../../models/user-account-service';

export interface CreateServiceAccountUser$Params {
      body: ServiceAccountUserRequest
}

export function createServiceAccountUser(http: HttpClient, rootUrl: string, params: CreateServiceAccountUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAccountService>> {
  const rb = new RequestBuilder(rootUrl, createServiceAccountUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAccountService>;
    })
  );
}

createServiceAccountUser.PATH = '/api/v1/service_account_users';
